import CustomerWiseVue from "@shared/customer-wise-vue";
import DatePicker from 'vue2-datepicker';
import { Component, Watch } from "vue-property-decorator";
import { Row, Col, Tabs, TabPane, Card, Badge, Table, TableColumn, Button } from "element-ui";
import Pager from "@components/pager/pager";
import * as moment from 'moment';
import template from "./index.vue";
import errorHanlder from '@shared/error-handler';
import predefinedCustomerSelect from '@components/predefined-customer-select/predefined-customer-select';
import facilitySelect from '@components/facility-select/facility-select';
import projectDashboardService from "@/services/projectDashboard-service";
import waittingBtn from "@/components/waitting-button/waitting-btn";
import util from "@shared/util";
import ItemAutoComplete from "@components/itemspec-auto-complete/itemspec-auto-complete";
import MultipleOrganizationAutoComplete from "@components/multiple-organization-auto-complete/multiple-organization-auto-complete";
import generalTaskService from "@/services/generalTask-service";

interface Paging {
    pageNo: number;
    limit: number;
}

@Component({
    mixins: [template],
    components: {
        DatePicker,
        ElRow: Row,
        ElCol: Col,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElCard: Card,
        ElBadge: Badge,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElButton: Button,
        Pager,
        predefinedCustomerSelect,
        facilitySelect,
        waittingBtn,
        ItemAutoComplete,
        MultipleOrganizationAutoComplete
    }
})

export default class Marketplace extends CustomerWiseVue {
    searchParams: any = {};
    updateListLoading: boolean = false;
    exportLoading: boolean = false;
    searchListLoading: boolean = false;
    updateListWindowsIsShow: boolean = false;
    newListData: object = {};
    projectDashboardView: Array<any> = [];
    paging: Paging = {
        limit: 10,
        pageNo: 1
    };
    totalCount: number = 0;
    statusArray: any = [
        {
            value: 'NEEDS_CUSTOMER_APPROVAL',
            label: 'Needs Customer Approval'
        },
        {
            value: 'CUSTOMER_APPROVED',
            label: 'Customer Approved'
        },
        {
            value: 'CUSTOMER_REJECTED',
            label: 'Customer Rejected'
        }
    ];


    onselectCustomerChange(payload: any) {
        this.searchParams.customerId = payload.id;
    }

    searchList(currentPage: number) {
        this.searchListLoading = true;
        this.paging.pageNo = currentPage;
        this.searchParams.paging = this.paging;
        projectDashboardService.searchList(this.searchParams).subscribe(
            res => {
                this.searchListLoading = false;
                this.projectDashboardView = res.projectDashboards.map((item: any) => {
                    item.isShowTask = false;
                    return item;
                });
                this.totalCount = res.paging.totalCount;
            },
            err => {
                this.searchListLoading = false;
                errorHanlder.handle(err);
            }
        );
    }

    reloadContent(page: any) {
        this.paging = {
            limit: page.pageSize,
            pageNo: page.currentPage
        };
        this.searchList(page.currentPage);
    }

    exportToExcel() {
        this.exportLoading = true;
        generalTaskService.export().then(
            res => {
                this.exportLoading = false;
                util.exportFile(res, "generalProjectDashboard.xlsx");
            },
            err => {
                this.exportLoading = false;
                errorHanlder.handle(err);
            }
        );
    }

    approvalOrReject(status: string, id: string, type: string) {
        const title = status;
        const content = status === 'Customer Approved' ? 'Are you sure approval this task?' : 'Are you sure reject this task?';
        const params = {
            id: id,
            customerApprovalStatus: status
        };
        this.popups({
            title: title,
            content: content,
            cancel: 'No',
            confirm: 'Yes'
        }).then((res: string) => {
            if (res === 'ok') {
                type === 'task' ? this.taskCustomerApproval(params, status) : this.projectDashboardCustomerApproval(params, status);
            }
        });
    }

    projectDashboardCustomerApproval(params: any, status: string) {
        projectDashboardService.customerApproval(params).subscribe(
            res => {
                this.$message.success(`${status} successful`);
            },
            err => {
                this.searchListLoading = false;
                errorHanlder.handle(err);
            }
        );
    }

    taskCustomerApproval(params: any, status: string) {
        generalTaskService.customerApproval(params).subscribe(
            res => {
                this.$message.success(`${status} successful`);
            },
            err => {
                this.searchListLoading = false;
                errorHanlder.handle(err);
            }
        );
    }

    showItemLevelTable(index: number) {
        this.projectDashboardView[index]['isShowTask'] = !this.projectDashboardView[index]['isShowTask'];
    }

    mounted() {
        this.searchList(1);
    }
}